export const CONTACT = {
  whatsappUrl:
    'https://wa.me/56926387467?text=Hola,%20necesito%20orientaci%C3%B3n%20de%20Evoluci%C3%B3n%20Chile.',
  phoneUrl: 'tel:+56992975014',
  whatsappDisplay: '+56 9 2638 7467',
  phoneDisplay: '+56 9 9297 5014',
  email: 'contacto@evolucionchileong.cl',
  address: 'Olea 2590, Isla de Maipo, Región Metropolitana, Chile',
}

export const ASSETS = {
  logo: 'https://cdn.magicpatterns.com/uploads/ouZWvThR2ShTVWrNm9K4mH/44.jpg',
  photo1: 'https://cdn.magicpatterns.com/uploads/3apTFvrEUpiPWT3Bp9Gk9f/11.jpg',
  photo2: 'https://cdn.magicpatterns.com/uploads/mqHv2SsvtzizYTVtvQw8Bs/22.jpg',
  photo3: 'https://cdn.magicpatterns.com/uploads/o8t9o8c994ZNFngB5o7M11/33.jpg',
}

export const SEDES_IMAGES = {
  polpaico: [
    'https://cdn.magicpatterns.com/uploads/3apTFvrEUpiPWT3Bp9Gk9f/11.jpg',
  ],
  naltahua: [
    'https://cdn.magicpatterns.com/uploads/mqHv2SsvtzizYTVtvQw8Bs/22.jpg',
  ],
  olea: [
    'https://cdn.magicpatterns.com/uploads/tTiWiHtKKJZPAqZ8iyHHha/centrolea1.jpg',
    'https://cdn.magicpatterns.com/uploads/xar7jfSM3R6uZtDs4ay8Ug/centrolea2.jpg',
    'https://cdn.magicpatterns.com/uploads/dUGHNLtSuHBNTQKHVbyN8N/centrolea3.jpg',
    'https://cdn.magicpatterns.com/uploads/fVPBLxCPHchNnGNs1383ti/centrolea4.jpg',
  ],
  femenina: [
    'https://cdn.magicpatterns.com/uploads/c59DEnTgoiKdxdJeSRuonX/centrofemenino1_v2.jpg',
    'https://cdn.magicpatterns.com/uploads/8KFjPuJuKJReW5AiAy2Thz/centrofemenino2.jpg',
    'https://cdn.magicpatterns.com/uploads/86WFPhEqtyeY6FH8Vamuwg/centrofemenino3_v2.png',
    'https://cdn.magicpatterns.com/uploads/3uKqQ47wkTVcScX3SdVfGi/centrofemenino4_v2.png',
  ],
}
